/**
 * Entrega ao usuário um PDF devolvido pela API.
 *
 * No desktop o download via âncora resolve. No mobile ele falha em boa parte dos
 * browsers (Safari iOS e webviews ignoram o atributo `download`), então o PDF é
 * exibido na aba que a tela reservou durante o clique — ver `reservarAbaPdf`.
 */
const TIPO_PDF = 'application/pdf'

/**
 * Reserva a aba de destino ainda dentro do clique do usuário.
 *
 * O PDF só fica pronto depois da resposta da API, quando o browser já não
 * considera mais que há interação do usuário e bloqueia a abertura da aba.
 * Retorna `null` quando não é caso de abrir aba ou quando o browser bloqueou.
 */
export function reservarAbaPdf(reservar = true) {
  if (!reservar || typeof window === 'undefined') {
    return null
  }

  return window.open('', '_blank') || null
}

export function entregarPdf(dados, nomeArquivo, abaReservada = null) {
  // A resposta do axios já vem como Blob, mas repassá-la por `new Blob([dados])`
  // apaga o content-type e o browser deixa de reconhecer o arquivo como PDF.
  const blob = dados instanceof Blob && dados.type === TIPO_PDF
    ? dados
    : new Blob([dados], { type: TIPO_PDF })

  const url = window.URL.createObjectURL(blob)

  if (abaReservada && !abaReservada.closed) {
    abaReservada.location.href = url
  } else {
    const link = document.createElement('a')
    link.href = url
    link.download = nomeArquivo
    link.rel = 'noopener'
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  // O browser ainda lê o blob depois do clique; revogar na hora aborta o download.
  setTimeout(() => window.URL.revokeObjectURL(url), 60000)
}

/** Fecha a aba reservada quando a geração do PDF falhou. */
export function descartarAbaPdf(abaReservada) {
  if (abaReservada && !abaReservada.closed) {
    abaReservada.close()
  }
}
